<template>
  <div class="mayday-root" :class="{ 'is-act-ended': isActEnded }">
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow12.webp" alt="" />
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules03.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="mayday-main" :style="{ 'margin-top': !isActEnded ? `-${topBarHeight + 46}px` : '10px' }">
      <div v-if="!isActEnded" class="mayday-hero" :style="{ 'padding-top': `${topBarHeight + 46}px` }">
        <p class="hero-sub">{{ $t('lang.WorldCup.k001') }}</p>
        <p class="hero-title">{{ $t('lang.WorldCup.k043') }}</p>
        <div class="hero-prize">
          <span class="hero-prize-num">2000</span>
          <img class="hero-prize-coin" :src="getMatchImg('coin')" alt="" />
        </div>
        <div class="hero-countdown">
          <img class="hero-cd-icon" src="./images/clock.webp" alt="" />
          <div class="cd-cell">
            <span class="cd-val">{{ countdownObj.countdownResult.days }}</span>
            <span class="cd-unit">{{ $t('lang.WorldCup.k089') }}</span>
          </div>
          <span class="cd-colon">:</span>
          <div class="cd-cell">
            <span class="cd-val">{{ countdownObj.countdownResult.hours }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k060') }}</span>
          </div>
          <span class="cd-colon">:</span>
          <div class="cd-cell">
            <span class="cd-val">{{ countdownObj.countdownResult.minutes }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k061') }}</span>
          </div>
          <span class="cd-colon">:</span>
          <div class="cd-cell">
            <span class="cd-val">{{ countdownObj.countdownResult.seconds }}</span>
            <span class="cd-unit">{{ $t('lang.ActCommon.k062') }}</span>
          </div>
        </div>
      </div>

      <div class="mayday-scroll">
        <div v-if="!isActEnded" class="segment-tabs">
          <div class="segment-inner" :class="{ 'segment-flow-locked': spinFlowActive }">
            <div class="segment-item" :class="{ 'segment-active': mainSegment === 'wheel' }" @click="switchPage('wheel')">
              {{ $t('lang.WorldCup.k030') }}
            </div>
            <div class="segment-item" :class="{ 'segment-active': mainSegment === 'rank' }" @click="switchPage('rank')">
              {{ $t('lang.WorldCup.k031') }}
            </div>
          </div>
        </div>

        <!-- Luck Draw -->
        <div v-show="!isActEnded && mainSegment === 'wheel'" class="mayday-wheel-segment">
          <div class="card lucky-card">
            <div class="card-head">
              <div class="card-head-left">
                <span>{{ $t('lang.WorldCup.k017') }}</span>
              </div>
              <img v-if="hasSpinHistory" class="ic-history" src="./images/history.webp" alt="" @click="handleToRecords" />
            </div>

            <div class="pool-switch" :class="{ 'pool-flow-locked': spinFlowActive }">
              <div class="pool-pill" :class="{ 'is-active': controlWheel.isSwitch === 'silver' }" @click="handleSwitchWheel('silver')">
                <img v-if="controlWheel.isSwitch === 'silver'" class="pool-pill-deco" src="./images/silver-pool-tab.webp" alt="" />
                <span class="pool-pill-label">{{ $t('lang.WorldCup.k018') }}</span>
              </div>
              <div class="pool-pill" :class="{ 'is-active': controlWheel.isSwitch === 'gold' }" @click="handleSwitchWheel('gold')">
                <img v-if="controlWheel.isSwitch === 'gold'" class="pool-pill-deco" src="./images/silver-pool-tab.webp" alt="" />
                <span class="pool-pill-label">{{ $t('lang.WorldCup.k019') }}</span>
              </div>
            </div>

            <div class="wheel-stage">
              <div class="wheel-pan mayday-wheel-pan">
                <div class="outher">
                  <div v-if="actInfo" ref="wapper" class="wapper">
                    <div class="part1">
                      <div v-if="panData && panData[0]" class="item one" :class="{ gotted: controlWheel.gotDrawId === panData[0].id }">
                        <div class="text">
                          <template v-if="panData[0].propType === 0">
                            <span class="text-tips">{{ panData[0].count }}</span>
                            <img v-if="panData[0].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[0].count }}</span>
                            <img v-if="panData[0].propType !== 10" :src="resolveMatchImg(panData[0].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[1]" class="item two" :class="{ gotted: controlWheel.gotDrawId === panData[1].id }">
                        <div class="text">
                          <template v-if="panData[1].propType === 0">
                            <span class="text-tips">{{ panData[1].count }}</span>
                            <img v-if="panData[1].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[1].count }}</span>
                            <img v-if="panData[1].propType !== 10" :src="resolveMatchImg(panData[1].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[2]" class="item three" :class="{ gotted: controlWheel.gotDrawId === panData[2].id }">
                        <div class="text">
                          <template v-if="panData[2].propType === 0">
                            <span class="text-tips">{{ panData[2].count }}</span>
                            <img v-if="panData[2].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[2].count }}</span>
                            <img v-if="panData[2].propType !== 10" :src="resolveMatchImg(panData[2].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[3]" class="item four" :class="{ gotted: controlWheel.gotDrawId === panData[3].id }">
                        <div class="text">
                          <template v-if="panData[3].propType === 0">
                            <span class="text-tips">{{ panData[3].count }}</span>
                            <img v-if="panData[3].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[3].count }}</span>
                            <img v-if="panData[3].propType !== 10" :src="resolveMatchImg(panData[3].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="part2">
                      <div v-if="panData && panData[4]" class="item five" :class="{ gotted: controlWheel.gotDrawId === panData[4].id }">
                        <div class="text">
                          <template v-if="panData[4].propType === 0">
                            <span class="text-tips">{{ panData[4].count }}</span>
                            <img v-if="panData[4].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[4].count }}</span>
                            <img v-if="panData[4].propType !== 10" :src="resolveMatchImg(panData[4].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[5]" class="item six" :class="{ gotted: controlWheel.gotDrawId === panData[5].id }">
                        <div class="text">
                          <template v-if="panData[5].propType === 0">
                            <span class="text-tips">{{ panData[5].count }}</span>
                            <img v-if="panData[5].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[5].count }}</span>
                            <img v-if="panData[5].propType !== 10" :src="resolveMatchImg(panData[5].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[6]" class="item seven" :class="{ gotted: controlWheel.gotDrawId === panData[6].id }">
                        <div class="text">
                          <template v-if="panData[6].propType === 0">
                            <span class="text-tips">{{ panData[6].count }}</span>
                            <img v-if="panData[6].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[6].count }}</span>
                            <img v-if="panData[6].propType !== 10" :src="resolveMatchImg(panData[6].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                      <div v-if="panData && panData[7]" class="item eight" :class="{ gotted: controlWheel.gotDrawId === panData[7].id }">
                        <div class="text">
                          <template v-if="panData[7].propType === 0">
                            <span class="text-tips">{{ panData[7].count }}</span>
                            <img v-if="panData[7].count >= 200" :src="getMatchImg('coins')" />
                            <img v-else :src="getMatchImg('coin')" class="small-img" />
                          </template>
                          <template v-else>
                            <span class="text-tips">{{ panData[7].count }}</span>
                            <img v-if="panData[7].propType !== 10" :src="resolveMatchImg(panData[7].propType)" />
                            <img v-else src="./images/avatar-bar.webp" class="avatar-bar" />
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="wheel-pointer mayday-wheel-pointer" />
              </div>
              <div class="podium-deco">
                <img class="podium" src="./images/pan.webp" alt="" />
              </div>
            </div>

            <div class="ticket-row">
              <img class="tic" src="./images/ic_ticket.webp" alt="" />
              <span class="tic-x">x{{ actInfo && actInfo.ticketBalance != null ? actInfo.ticketBalance : 0 }}</span>
              <div class="tic-div"></div>
              <span class="tic-txt">{{ controlWheel.restSpins || 0 }} {{ $t('lang.WorldCup.k040') }}</span>
            </div>

            <div class="spin-btn-row">
              <div
                class="spin-pill spin-pill-primary"
                :class="{
                  'silver-on': spinCanX1,
                  'spin-off': !spinCanX1,
                }"
                @click="handleWheelPan(1)"
              >
                <span class="spin-pill-t">{{ $t('lang.WorldCup.k026') }} x1</span>
                <span class="spin-pill-sub">
                  <b>{{ poolSpinCost }}</b>
                  <img src="./images/ic_ticket.webp" alt="" class="sub-tic" />
                </span>
              </div>
              <div
                class="spin-pill spin-pill-primary"
                :class="{
                  'gold-on': spinCanX10,
                  'spin-off': !spinCanX10,
                }"
                @click="handleWheelPan(10)"
              >
                <span class="spin-pill-t">{{ $t('lang.WorldCup.k026') }} x10</span>
                <span class="spin-pill-sub">
                  <b>{{ poolSpinCost * 10 }}</b>
                  <img src="./images/ic_ticket.webp" alt="" class="sub-tic" />
                </span>
              </div>
            </div>
          </div>

          <!-- Ways to earn -->
          <div id="tasks-anchor" ref="tasksAnchor" class="card ways-card">
            <div class="card-head">
              <div class="card-head-left">
                <span>{{ $t('lang.WorldCup.k032') }}</span>
              </div>
            </div>
            <div class="ways-body">
              <div v-if="actInfo" class="stats-bar">
                <div class="stats-left">
                  <div class="stat">
                    <img src="./images/ic_point.webp" alt="" />
                    <span>{{ actInfo.score || 0 }}</span>
                  </div>
                  <div class="stat">
                    <img src="./images/cup.webp" alt="" />
                    <span>{{ statsBarRankCupLabel }}</span>
                  </div>
                </div>
                <div class="stats-rank-link" @click="switchPage('rank')">
                  {{ $t('lang.WorldCup.k039') }}
                  <img src="@/assets/packageAssets/common/arrow14.webp" alt="" />
                </div>
              </div>

              <div v-if="dailyTasksList.length" class="task-block task-block-daily">
                <p class="task-block-title">{{ $t('lang.WorldCup.k033') }}</p>
                <p class="task-block-sub">{{ $t('lang.WorldCup.k034') }}</p>
                <!-- Daily Tasks -->
                <div v-for="(dt, di) in dailyTasksList" :key="dt.id || di" class="task-row">
                  <div class="task-row-main">
                    <div class="task-desc task-desc-plain">
                      <MyPLabel class="task-desc" :str="dt.title" :numsOption="dt.numsOption || [{ value: 20 }]" />
                      <span class="task-desc-proc">&nbsp;({{ dt.proc }}/{{ dt.target }})</span>
                    </div>
                    <div class="task-row-reward">
                      <div v-for="(r, ri) in dt.rewards" :key="'d' + di + '-' + ri" class="task-reward-item">
                        <img v-if="r.kind === 'ticket'" class="task-reward-ic" src="./images/ic_ticket.webp" alt="" />
                        <img v-else class="task-reward-ic" src="./images/ic_point.webp" alt="" />
                        <span>+{{ r.value }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="Number(dt.state) === 0" class="task-go" @click="appAction(dt.action)">
                    {{ $t('lang.WorldCup.k029') }}
                  </div>
                  <div v-else class="task-btn-wait">
                    <!-- prettier-ignore -->
                    <template v-if="dailyCountdownObj && dailyCountdownObj.countdownResult">
                      {{ dailyCountdownObj.countdownResult.hours }}:{{ dailyCountdownObj.countdownResult.minutes }}:{{dailyCountdownObj.countdownResult.seconds}}
                    </template>
                    <template v-else>00:00:00</template>
                  </div>
                </div>
              </div>

              <div v-if="dailyTasksList.length && showStreakTaskBlock" class="task-block-divider" />

              <div v-if="showStreakTaskBlock" class="task-block task-block-streak">
                <p class="task-block-title">{{ $t('lang.WorldCup.k035') }}</p>
                <p class="task-block-sub">{{ $t('lang.WorldCup.k036') }}</p>
                <!-- Streak Tasks -->
                <div v-for="(st, si) in streakTasksList" :key="st.id || si" class="task-row task-row-streak">
                  <div class="task-row-main">
                    <div class="task-streak-head">
                      <MyPLabel class="task-desc streak-task-title" :str="st.title" :numsOption="st.numsOption || [{ value: 20 }]" />
                    </div>
                    <div class="task-streak-bar-row">
                      <div class="task-streak-bar">
                        <div class="task-streak-bar-fill" :style="{ width: streakBarPercent(st) }" />
                      </div>
                      <span class="task-streak-progress" :class="{ 'is-done': streakProgressDone(st) }">({{ st.proc }}/{{ st.target }})</span>
                    </div>
                    <div class="task-row-reward">
                      <div v-for="(r, ri) in st.rewards || []" :key="ri" class="task-reward-item">
                        <img v-if="r.kind === 'ticket'" class="task-reward-ic" src="./images/ic_ticket.webp" alt="" />
                        <img v-else class="task-reward-ic" src="./images/ic_point.webp" alt="" />
                        <span>+{{ r.value }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="streakSideButtonUi(st) === 'go'" class="task-go" @click="appAction(st.action)">
                    {{ $t('lang.WorldCup.k029') }}
                  </div>
                  <template v-else>
                    <div v-if="streakSideButtonUi(st) === 'wait'" class="task-btn-wait">
                      <!-- prettier-ignore -->
                      <template v-if="dailyCountdownObj && dailyCountdownObj.countdownResult">{{ dailyCountdownObj.countdownResult.hours }}:{{ dailyCountdownObj.countdownResult.minutes }}:{{dailyCountdownObj.countdownResult.seconds}}</template>
                      <template v-else>00:00:00</template>
                    </div>
                    <div v-else class="task-streak-done">
                      <img src="./images/claimed.webp" alt="" width="24" height="24" />
                    </div>
                  </template>
                </div>
              </div>

              <div v-if="dailyTasksList.length || showStreakTaskBlock" class="task-block-divider" />

              <div class="task-block">
                <p class="task-block-title">{{ $t('lang.WorldCup.k037') }}</p>
                <p class="task-block-sub">{{ $t('lang.WorldCup.k038') }}</p>
                <!-- Repeatable Tasks -->
                <div v-for="(task, idx) in repeatableTasksList" :key="idx" class="task-row">
                  <div class="task-row-main">
                    <MyPLabel class="task-desc" :str="task.title" :numsOption="task.numsOption || [{ value: 20 }]" />
                    <div class="task-row-reward">
                      <div v-for="(r, ri) in task.rewards" :key="ri" class="task-reward-item">
                        <template v-if="r.value">
                          <img v-if="r.kind === 'ticket'" class="task-reward-ic" src="./images/ic_ticket.webp" alt="" />
                          <img v-else class="task-reward-ic" src="./images/ic_point.webp" alt="" />
                          <span>+{{ r.value }}</span>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="task-go" @click="appAction(task.action)">{{ $t('lang.WorldCup.k029') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <act-male-rank v-if="isActEnded || mainSegment === 'rank'" @go-earn="onGoEarnFromRank" />
      </div>
    </div>

    <div v-if="showSuccess" class="act-mask">
      <div class="dia-bg">
        <div class="con-block">
          <div class="gifts-dia-head">
            <span>{{ $t('lang.WorldCup.k024') }}</span>
          </div>
          <div v-if="showSuccess === 1" class="gifts-reward1">
            <div v-for="reward in rewards" :key="reward.id" class="gifts-reward1-cell">
              <div class="img-wrap">
                <img v-if="reward.propType !== 10" :src="resolveMatchImg(reward.propType)" alt="" />
                <img v-else class="avatar-bar" src="./images/avatar-bar.webp" />
              </div>
              <div class="rewards-count">x{{ reward.count }}</div>
            </div>
          </div>

          <div v-else class="gifts-reward2">
            <div
              v-for="(reward, rewardIdx) in rewards"
              :key="reward.id"
              class="gifts-reward2-cell gifts-reward2-cell--stagger"
              :style="{ animationDelay: `${rewardIdx * 40}ms` }"
            >
              <div class="img-wrap">
                <img v-if="reward.propType !== 10" :src="resolveMatchImg(reward.propType)" alt="" />
                <img v-else class="avatar-bar" src="./images/avatar-bar.webp" />
              </div>
              <div class="rewards-count">x{{ reward.count }}</div>
            </div>
          </div>

          <div class="gifts-confirm" @click="showSuccess = 0">
            <span>{{ $t('lang.ActCommon.k100') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { maleSpinHome, maleSpinDraw, newSpinIdempotencyKey } from './apidir/api.js'
import {
  normalizeMaleSpinHome,
  mapApiTasksToRows,
  mapSpinResultsToPanRewards,
  matchWheelSliceId,
  mapDrawOptionRewardsToPan,
  mapSilverDrawOptionRewardsToPan,
} from './utils/maleSpinAdapter.js'

import scrollMixin from '@/hooks/scroll.mixin.js'
import CountDownClass from '@/utils/count-down.js'
import ActMaleRank from './actMaleRank.vue'

const angles = [337.5, 292.5, 247.5, 202.5, 157.5, 112.5, 67.5, 22.5]

const WHEEL_SPIN_BASIC = 1800
const WHEEL_STEP_FACTOR = 0.05
const WHEEL_X10_INTERVAL = 20
const WHEEL_X10_DURATION_MS = 1500
const WHEEL_X1_INTERVAL = 10
const WHEEL_X1_DURATION_MS = 10000
/** X1 进度缓动：压缩末尾小角度耗时（越大收尾越快，2~3 较自然） */
const WHEEL_X1_PROGRESS_POWER = 3
/** X1 剩余角度小于该值时提前结束，避免末尾空转 */
const WHEEL_X1_SNAP_DEG = 8

/** 与 doWheelPan 逐步减速一致，按进度 0~1 计算当前角度 */
function wheelRotationAtProgress(target, progress, stepFactor = WHEEL_STEP_FACTOR) {
  let begin = 0
  let sim = 0
  let totalSteps = 0
  while (sim <= target) {
    totalSteps += 1
    sim += Math.ceil(target - sim) * stepFactor
  }
  const stepCount = Math.floor(Math.min(1, progress) * totalSteps)
  for (let i = 0; i < stepCount; i += 1) {
    begin += Math.ceil(target - begin) * stepFactor
  }
  return begin
}

/** 将墙钟线性进度映射为步进进度，power>1 时提前走完末尾小步 */
function wheelProgressEaseOut(progress, power = 1) {
  const p = Math.min(1, Math.max(0, progress))
  if (power <= 1) return p
  return 1 - Math.pow(1 - p, power)
}

export default {
  mixins: [scrollMixin],
  components: {
    ActMaleRank,
  },
  data() {
    return {
      mainSegment: 'wheel',
      actInfo: null,
      isWheeling: false,
      isPosting: false,
      controlWheel: {
        isSwitch: 'silver',
        gotDrawId: null,
        restSpins: 0,
      },
      panData: null,
      boardData: {
        num1Reward: 2000,
      },
      showSuccess: 0,
      rewards: [],
      countdownObj: null,
      dailyCountdownObj: null,
      spinTasksFromApi: null,
      _spinPageWasHidden: false,
      _pendingResumeRefresh: false,
    }
  },
  watch: {
    isWheeling(val) {
      if (!val) this.tryFlushPendingResumeRefresh()
    },
    isPosting(val) {
      if (!val) this.tryFlushPendingResumeRefresh()
    },
  },
  computed: {
    isActEnded() {
      if (!this.actInfo) return false
      const st = this.actInfo.eventStatus
      if (st === 'CLOSED' || st === 'SETTLING') return true
      if (Number(this.actInfo.countdown) <= 0) return true
      const cr = this.countdownObj && this.countdownObj.countdownResult
      if (cr && typeof cr.days !== 'undefined' && cr.days === '00' && cr.hours === '00' && cr.minutes === '00' && cr.seconds === '00') {
        return true
      }
      return false
    },
    hasSpinHistory() {
      return this.actInfo && this.actInfo.hasSpinHistory
    },
    dailyTasksList() {
      const tasks = this.spinTasksFromApi
      if (!tasks || !tasks.dailyTasks) return []
      return mapApiTasksToRows(tasks.dailyTasks, this.$t.bind(this), 'daily')
    },
    streakTasksList() {
      const tasks = this.spinTasksFromApi
      if (!tasks || !tasks.streakTasks) return []
      return mapApiTasksToRows(tasks.streakTasks, this.$t.bind(this), 'streak')
    },
    showStreakTaskBlock() {
      const list = this.streakTasksList
      if (!list.length) return false
      return list.some((st) => this.streakSideButtonUi(st) !== 'done')
    },
    repeatableTasksList() {
      const tasks = this.spinTasksFromApi
      if (!tasks || !tasks.repeatableTasks) return []
      return mapApiTasksToRows(tasks.repeatableTasks, this.$t.bind(this), 'repeatable')
    },
    currentPoolDrawOpt() {
      if (!this.actInfo || !this.actInfo.drawOptions) return null
      const key = this.controlWheel.isSwitch === 'gold' ? 'gold' : 'silver'
      return this.actInfo.drawOptions[key] || null
    },
    poolSpinCost() {
      const opt = this.currentPoolDrawOpt
      if (opt && opt.cost != null) return Number(opt.cost) || 0
      const w =
        this.controlWheel.isSwitch === 'gold' ? this.actInfo && this.actInfo.advancedPrizeWheel : this.actInfo && this.actInfo.normalPrizeWheel
      return Number(w && w.costPoint) || 1
    },
    spinCanX1() {
      const opt = this.currentPoolDrawOpt
      if (opt) return !!opt.canSpinX1
      return (Number(this.controlWheel.restSpins) || 0) >= 1
    },
    spinCanX10() {
      const opt = this.currentPoolDrawOpt
      if (opt) return !!opt.canSpinX10
      return (Number(this.controlWheel.restSpins) || 0) >= 10
    },
    statsBarRankCupLabel() {
      if (!this.actInfo) return '--'
      const score = Number(this.actInfo.score)
      if (!Number.isFinite(score) || score < 3) return '--'
      const r = this.actInfo.rank
      if (r == null || r === '' || r === '--') return '--'
      const n = Number(r)
      if (!Number.isFinite(n) || n < 1) return '--'
      if (n > 100) return '100+'
      return `#${n}`
    },
    spinFlowActive() {
      return this.isPosting || this.isWheeling
    },
  },
  methods: {
    handleToRule() {
      this.$router.push({ path: '/worldcup-rules-male', query: { from: 'worldcup-main-male' } })
    },
    switchPage(arg) {
      if (this.spinFlowActive) return
      this.mainSegment = arg
    },
    scrollTasksSectionIntoView() {
      const el = this.$refs.tasksAnchor
      if (!el || typeof el.getBoundingClientRect !== 'function') return
      const rect = el.getBoundingClientRect()
      if (!rect.width && !rect.height) return
      const cur = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const top = Math.max(0, rect.top + cur - 8)
      if (typeof window.scrollTo === 'function') {
        try {
          window.scrollTo({ left: 0, top, behavior: 'auto' })
        } catch (e) {
          window.scrollTo(0, top)
        }
      }
      document.documentElement.scrollTop = top
      document.body.scrollTop = top
    },
    onGoEarnFromRank() {
      if (this.isActEnded) return
      if (this.spinFlowActive) return
      this.mainSegment = 'wheel'
      this.$nextTick(() => {
        this.$nextTick(() => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              this.scrollTasksSectionIntoView()
            })
          })
        })
      })
    },
    handleToRecords() {
      this.$router.push({ path: '/worldcup-records-male', query: { from: 'worldcup-main-male' } })
    },
    syncDailyCountdown(resData) {
      if (this.dailyCountdownObj && this.dailyCountdownObj.animationFrameId) {
        cancelAnimationFrame(this.dailyCountdownObj.animationFrameId)
        this.dailyCountdownObj.animationFrameId = null
      }
      this.dailyCountdownObj = null
      const sec = Number(resData.dailyCountdown)
      if (sec > 0) {
        this.dailyCountdownObj = new CountDownClass()
        this.dailyCountdownObj.initCountDown(sec, 'HMS')
      }
    },
    streakBarPercent(st) {
      const p = Number(st && st.proc)
      const t = Number(st && st.target)
      if (!t || Number.isNaN(t)) return '0%'
      const pct = Math.min(100, Math.max(0, Math.round(((Number.isNaN(p) ? 0 : p) / t) * 100)))
      return `${pct}%`
    },
    streakProgressDone(st) {
      const p = Number(st && st.proc)
      const t = Number(st && st.target)
      if (!t || Number.isNaN(t)) return false
      return (Number.isNaN(p) ? 0 : p) >= t
    },
    streakSideButtonUi(st) {
      const t = Number(st && st.target)
      const p = Number(st && st.proc)
      if (!Number.isFinite(t) || t <= 0) return 'go'
      const pv = Number.isFinite(p) ? p : 0
      if (pv >= t) return 'done'
      if (pv > 0) return 'wait'
      return 'go'
    },
    handleSwitchWheel(type) {
      if (this.spinFlowActive) return
      const poolKey = type === 'gold' ? 'gold' : 'silver'
      const opt = this.actInfo && this.actInfo.drawOptions && this.actInfo.drawOptions[poolKey]
      if (opt) {
        this.controlWheel.restSpins = Number(opt.availableSpins) || 0
        const fromDraw = type === 'silver' ? mapSilverDrawOptionRewardsToPan(opt.rewards) : mapDrawOptionRewardsToPan(opt.rewards)
        this.panData = fromDraw.length ? fromDraw : []
        if (!this.panData.length) {
          const w = type === 'gold' ? this.actInfo.advancedPrizeWheel : this.actInfo.normalPrizeWheel
          this.panData = (w && w.rewards) || []
        }
      } else {
        if (type === 'silver' && this.actInfo && this.actInfo.normalPrizeWheel) {
          this.controlWheel.restSpins = this.actInfo.normalPrizeWheel.restSpins || 0
          this.panData = this.actInfo.normalPrizeWheel.rewards
        }
        if (type === 'gold' && this.actInfo && this.actInfo.advancedPrizeWheel) {
          this.controlWheel.restSpins = this.actInfo.advancedPrizeWheel.restSpins || 0
          this.panData = this.actInfo.advancedPrizeWheel.rewards || []
        }
      }
      this.controlWheel.isSwitch = type
    },
    resolveMatchImg(propType) {
      if (this.propsMap[propType]) {
        return this.getMatchImg(this.propsMap[propType])
      }
      return ''
    },
    handleWheelPan(spinCount) {
      const poolKey = this.controlWheel.isSwitch === 'gold' ? 'gold' : 'silver'
      const opt = this.actInfo && this.actInfo.drawOptions && this.actInfo.drawOptions[poolKey]
      let canSpin = false
      if (opt) {
        canSpin = spinCount === 1 ? !!opt.canSpinX1 : !!opt.canSpinX10
      } else {
        const spins = Number(this.controlWheel.restSpins) || 0
        canSpin = (spinCount === 1 && spins >= 1) || (spinCount === 10 && spins >= 10)
      }
      if (!canSpin) {
        return
      }

      if (!this.isWheeling) {
        this.traceAction({ Action: 'Click', APosition: 'button', AValue: 'may-day-spin' })
        this.controlWheel.gotDrawId = null
        this.$nextTick(() => {
          if (this.isPosting) {
            return
          }
          this.isPosting = true
          const poolType = poolKey === 'gold' ? 'GOLD' : 'SILVER'
          maleSpinDraw({
            poolType,
            spinCount,
            idempotencyKey: newSpinIdempotencyKey(),
          })
            .then((resData) => {
              if (resData && !resData.error && resData.results && resData.results.length) {
                const panRewards = mapSpinResultsToPanRewards(resData.results)
                const finish = () => {
                  this.rewards = panRewards
                  this.showSuccess = resData.results.length === 1 ? 1 : 10
                  this.fetchBaseData(() => this.handleSwitchWheel(this.controlWheel.isSwitch))
                }
                // 抽X1
                if (resData.results.length === 1) {
                  const gotId = matchWheelSliceId(this.panData, resData.results[0])
                  this.resolveData(
                    gotId,
                    () => {
                      this.controlWheel.gotDrawId = gotId
                      finish()
                    },
                    spinCount
                  )
                }
                // 抽X10
                else {
                  this.resolveData('x10', finish, spinCount)
                }
              }
            })
            .finally(() => {
              this.isPosting = false
            })
        })
      }
    },
    resolveData(gotDrawId, cbFn, spinCount = 10) {
      const isX1 = spinCount === 1
      const x1Opts = {
        interval: WHEEL_X1_INTERVAL,
        durationMs: WHEEL_X1_DURATION_MS,
        progressPower: WHEEL_X1_PROGRESS_POWER,
        snapDeg: WHEEL_X1_SNAP_DEG,
      }
      const x10Opts = { interval: WHEEL_X10_INTERVAL, durationMs: WHEEL_X10_DURATION_MS }

      if (gotDrawId === 'x10') {
        this.doWheelPan(0, cbFn, x10Opts)
        return
      }

      const tempArr = this.panData || []
      const originIndex = tempArr.findIndex((item) => item.id === gotDrawId)
      if (originIndex > -1) {
        this.doWheelPan(angles[originIndex], cbFn, isX1 ? x1Opts : x10Opts)
      } else {
        this.doWheelPan(0, cbFn, isX1 ? x1Opts : x10Opts)
      }
    },
    doWheelPan(angle, fn, opts = 50) {
      let interval = 50
      let durationMs = null
      let progressPower = 1
      let snapDeg = 0
      if (typeof opts === 'number') {
        interval = opts
      } else if (opts && typeof opts === 'object') {
        interval = opts.interval ?? 50
        durationMs = opts.durationMs ?? null
        progressPower = opts.progressPower ?? 1
        snapDeg = opts.snapDeg ?? 0
      }

      this.isWheeling = true

      let begin = 0
      const target = WHEEL_SPIN_BASIC + Number(angle)
      const startTime = Date.now()

      const timer = setInterval(() => {
        if (durationMs != null) {
          const elapsed = Date.now() - startTime
          const done = elapsed >= durationMs
          const linearProgress = done ? 1 : elapsed / durationMs
          const progress = wheelProgressEaseOut(linearProgress, progressPower)
          begin = wheelRotationAtProgress(target, progress)
          const nearTarget = snapDeg > 0 && target - begin <= snapDeg
          if (done || nearTarget) {
            begin = target + 1
          }
        } else if (begin > target) {
          this.isWheeling = false
          clearInterval(timer)
          fn && fn()
          return
        } else {
          begin += Math.ceil(target - begin) * WHEEL_STEP_FACTOR
        }

        const wrap = this.$refs.wapper
        if (wrap) wrap.style.transform = 'rotate(' + begin + 'deg)'

        if (durationMs != null && begin > target) {
          this.isWheeling = false
          clearInterval(timer)
          fn && fn()
        }
      }, interval)
    },
    fetchBaseData(cbFn) {
      maleSpinHome().then((raw) => {
        if (raw && !raw.error) {
          this.spinTasksFromApi = raw.tasks || null
          this.actInfo = normalizeMaleSpinHome(raw)
          if (!this.actInfo) return
          if (this.actInfo.endTimestamp) {
            if (this.countdownObj && this.countdownObj.animationFrameId) {
              cancelAnimationFrame(this.countdownObj.animationFrameId)
              this.countdownObj.animationFrameId = null
            }
            this.countdownObj.initCountDown(this.actInfo.endTimestamp, 'DHMS', true)
          }
          this.syncDailyCountdown(this.actInfo)
          cbFn && cbFn()
        }
      })
    },
    refresh() {
      this.fetchBaseData(() => this.handleSwitchWheel(this.controlWheel.isSwitch))
    },
    handleVisibilityChange() {
      const state = document.visibilityState || document.webkitVisibilityState || document.mozVisibilityState || 'visible'
      if (state === 'hidden') {
        this._spinPageWasHidden = true
        return
      }
      if (state !== 'visible' || !this._spinPageWasHidden) {
        return
      }
      this._spinPageWasHidden = false
      if (this.isWheeling || this.isPosting) {
        this._pendingResumeRefresh = true
        return
      }
      this.refresh()
    },
    tryFlushPendingResumeRefresh() {
      if (!this._pendingResumeRefresh || this.isWheeling || this.isPosting) return
      this._pendingResumeRefresh = false
      this.refresh()
    },
  },
  created() {
    this.countdownObj = new CountDownClass()
    this.traceAction({ Action: 'Click', APosition: 'entrance', AValue: 'may-day' })
    this.fetchBaseData(() => {
      const fromApi = this.actInfo && this.actInfo.defaultPool
      if (fromApi === 'gold' || fromApi === 'silver') {
        this.handleSwitchWheel(fromApi)
        return
      }
      const silverSpins = (this.actInfo && this.actInfo.normalPrizeWheel && this.actInfo.normalPrizeWheel.restSpins) || 0
      const defaultPool = silverSpins >= 10 ? 'gold' : 'silver'
      this.handleSwitchWheel(defaultPool)
    })
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    if (this.countdownObj && this.countdownObj.animationFrameId) {
      cancelAnimationFrame(this.countdownObj.animationFrameId)
    }
    if (this.dailyCountdownObj && this.dailyCountdownObj.animationFrameId) {
      cancelAnimationFrame(this.dailyCountdownObj.animationFrameId)
    }
  },
}
</script>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.mayday-root {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #3a4fff;

  &.is-act-ended {
    .mayday-scroll {
      padding-top: 8px;
    }
  }

  .custom-nav-block {
    ::v-deep .van-bar.van-nav-bar {
      background: transparent;
    }
    ::v-deep .van-bar .van-icon {
      color: #fff;
    }
  }

  .nav-default {
    background: transparent;
  }

  .nav-scrolling {
    background: #3a4fff;
  }

  .mayday-main {
    position: relative;

    .mayday-hero {
      width: 100%;
      aspect-ratio: 750 / 666;
      background: url(./images/main-bg.webp) top left / 100% 100% no-repeat;
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 0 12px;

      .hero-sub {
        margin: 0;
        font-family: 'TikTokSans-Bold';
        font-weight: 900;
        font-size: 16px;
        line-height: 20px;
        color: #fff;
      }

      .hero-title {
        font-family: 'TikTokSans-Bold';
        font-weight: 900;
        font-size: 40px;
        line-height: 52px;
        text-align: center;
        color: #fff;
        text-shadow: 0 4px 0 rgba(0, 32, 63, 0.7);
        max-width: 340px;
      }

      .hero-prize {
        display: flex;
        align-items: center;
        gap: 12px;
        padding-left: 16px;

        .hero-prize-num {
          font-family: 'TikTokSans-Bold';
          font-weight: 900;
          font-size: 60px;
          line-height: 78px;
          color: #ffffff;
          text-shadow: 0 4px 0 rgba(0, 32, 63, 0.7);
        }

        .hero-prize-coin {
          width: 40px;
          height: 40px;
          object-fit: contain;
        }
      }

      .hero-countdown {
        margin-top: 14px;
        display: flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 20px;
        border: 0.5px solid rgba(255, 255, 255, 0.5);
        background: rgba(62, 160, 56, 0.92);

        .hero-cd-icon {
          width: 20px;
          height: 20px;
          margin-right: 2px;
        }

        .cd-cell {
          flex: 1 1 0;
          min-width: 40px;
          flex-shrink: 1;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          flex-wrap: nowrap;
          gap: 0;
          padding: 4px 4px;
          box-sizing: border-box;
          border-radius: 4px;
          white-space: nowrap;

          .cd-val {
            font-family: 'TikTokSans-Bold';
            font-weight: 800;
            font-size: 16px;
            color: #ffffff;
          }

          .cd-unit {
            font-family: 'TikTokSans-Bold';
            font-weight: 700;
            font-size: 11px;
            line-height: 16px;
            color: #ffffff;
          }
        }

        .cd-colon {
          flex-shrink: 0;
          color: #fff;
          font-weight: 700;
          font-size: 14px;
          margin: 0 3px;
        }
      }
    }

    .mayday-scroll {
      position: relative;
      z-index: 3;
      padding: 0 10px 48px;
      box-sizing: border-box;

      .segment-tabs {
        display: flex;
        justify-content: center;
        padding: 12px 2px 16px;
        box-sizing: border-box;

        .segment-inner {
          display: flex;
          align-items: center;
          width: 100%;
          max-width: 355px;
          padding: 6px;
          border-radius: 60px;
          background: #2735a6;
          backdrop-filter: blur(11.75px);
          box-sizing: border-box;

          .segment-item {
            flex: 1;
            min-width: 0;
            padding: 5px 16px;
            border-radius: 20px;
            font-family: 'TikTokSans-Bold';
            font-weight: 800;
            font-size: 16px;
            line-height: 21px;
            text-align: center;
            color: rgba(255, 255, 255, 0.8);
            &.segment-active {
              background: #fff;
              color: #000000;
            }
          }

          &.segment-flow-locked {
            pointer-events: none;
            opacity: 0.65;
          }
        }
      }

      .card {
        width: 355px;
        max-width: 100%;
        margin: 0 auto 16px;
        border-radius: 20px;
        border: 2px solid #fff;
        background: #fff;
        box-sizing: border-box;
      }

      .lucky-card {
        .card-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;

          .card-head-left {
            display: flex;
            align-items: center;
            gap: 8px;
            font-family: 'TikTokSans-Bold';
            font-weight: 900;
            font-style: italic;
            font-size: 20px;
            line-height: 24px;
            color: #000000;
          }

          .ic-history {
            width: 20px;
            height: 20px;
          }
        }

        .pool-switch {
          display: flex;
          align-items: flex-end;
          width: calc(100% - 32px);
          max-width: 323px;
          margin: 10px auto 0;
          padding: 0;
          border-bottom: 1px solid #f1f1f1;
          overflow: visible;

          &.pool-flow-locked {
            pointer-events: none;
            opacity: 0.75;
          }

          .pool-pill {
            position: relative;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 7px;
            background: none;
            border-radius: 0;

            .pool-pill-label {
              position: relative;
              z-index: 2;
              font-family: 'TikTokSans-Bold', sans-serif;
              font-weight: 800;
              font-size: 14px;
              line-height: 18px;
              color: #5f656a;
              white-space: nowrap;
            }

            .pool-pill-deco {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              object-fit: contain;
              pointer-events: none;
              z-index: 1;
            }

            &.is-active {
              .pool-pill-label {
                color: #000000;
              }

              &::after {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                bottom: -1px;
                height: 1px;
                background: #169f52;
                border-radius: 4px 4px 0 0;
                z-index: 3;
              }
            }
          }
        }

        .wheel-stage {
          position: relative;
          width: 355px;
          max-width: 100%;
          min-height: 320px;
          margin: 24px auto 0;
          pointer-events: none;

          .mayday-wheel-pan.wheel-pan {
            width: 315px;
            max-width: 100%;
            height: 315px;
            margin: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            background: url(./images/wheel-pan.webp) top left / 100% auto no-repeat;
            position: relative;
            transform: rotateZ(-22.5deg);
            z-index: 2;

            .outher {
              width: 250px;
              height: 250px;
              position: relative;
              border-radius: 50%;
              overflow: hidden;
              box-shadow: 0 4px 16px rgba(0, 129, 179, 0.2);
              transform: rotateZ(22.5deg);

              .wapper {
                width: 250px;
                height: 250px;
                border-radius: 50%;

                .part1 {
                  position: absolute;
                  width: 125px;
                  height: 250px;
                  right: 0;
                  overflow: hidden;
                  text-align: center;

                  .text {
                    position: absolute;
                    top: 16px;
                    left: 11%;
                    transform: rotate(23deg);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  }

                  .item {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    transform-origin: left center;
                  }

                  .item.one {
                    background-color: #6ff2a8;
                    z-index: 1;
                  }

                  .item.two {
                    background-color: #f1fff7;
                    transform: rotate(45deg);
                    z-index: 2;
                  }

                  .item.three {
                    background-color: #6ff2a8;
                    transform: rotate(90deg);
                    z-index: 3;
                  }

                  .item.four {
                    background-color: #f1fff7;
                    transform: rotate(135deg);
                    z-index: 4;
                  }
                }

                .part2 {
                  position: absolute;
                  width: 125px;
                  height: 250px;
                  left: 0;
                  overflow: hidden;

                  .text {
                    position: absolute;
                    top: 16px;
                    left: 57%;
                    transform: rotate(-24deg);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  }

                  .item {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    transform-origin: right center;
                  }

                  .item.five {
                    background-color: #6ff2a8;
                    transform: rotate(-135deg);
                    z-index: 4;
                  }

                  .item.six {
                    background-color: #f1fff7;
                    transform: rotate(-90deg);
                    z-index: 3;
                  }

                  .item.seven {
                    background-color: #6ff2a8;
                    transform: rotate(-45deg);
                    z-index: 2;
                  }

                  .item.eight {
                    background-color: #f1fff7;
                    z-index: 1;
                  }
                }

                .part1,
                .part2 {
                  .gotted {
                    background: #d9d9d9 !important;
                    .text {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      .text-tips {
                        color: #ffffff !important;
                      }
                    }
                  }
                }

                .text {
                  font-size: 0;
                  .text-tips {
                    min-height: 26px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-family: 'Inter-Tight';
                    font-size: 14px;
                    font-weight: bold;
                    line-height: 20px;
                    color: #000000;
                  }

                  > img {
                    width: 36px;
                  }
                  > img.avatar-bar {
                    width: 30px;
                  }
                  > img.small-img {
                    width: 34px;
                  }
                }
              }
            }

            .mayday-wheel-pointer.wheel-pointer {
              position: absolute;
              top: 50%;
              left: 50%;
              z-index: 99;
              width: 50px;
              height: 52px;
              transform: translate3d(-48%, -55%, 0) rotateZ(22.5deg);
              background: url(./images/pointer.webp) center / contain no-repeat;
            }
          }

          .podium-deco {
            pointer-events: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            margin-top: -18px;
            z-index: 0;

            .podium {
              width: 100%;
              max-width: 355px;
            }
          }
        }

        .ticket-row {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          margin: 4px 0 10px;
          font-family: 'TikTokSans-Bold';
          font-weight: 700;
          font-size: 16px;
          color: #353a3f;

          .tic {
            width: 32px;
            height: 32px;
          }

          .tic-div {
            width: 1px;
            height: 16px;
            background: #d4d4d4;
          }
        }

        .spin-btn-row {
          display: flex;
          justify-content: space-between;
          align-items: stretch;
          gap: 16px;
          min-height: 72px;
          padding: 8px 16px 16px;
          box-sizing: border-box;

          .spin-pill {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 12px;
            padding: 10px 8px 8px;
            text-align: center;
            box-sizing: border-box;

            .spin-pill-t {
              display: block;
              font-family: 'TikTokSans-Bold';
              font-weight: 900;
              font-size: 18px;
              line-height: 22px;
            }

            .spin-pill-sub {
              display: inline-flex;
              align-items: center;
              gap: 4px;
              margin-top: 6px;
              padding: 0 8px;
              border-radius: 20px;
              background: rgba(255, 255, 255, 0.85);
              font-family: 'TikTokSans-Bold';
              font-weight: 900;
              font-size: 12px;

              .sub-tic {
                width: 24px;
                height: 24px;
              }
            }
          }

          .spin-pill-primary {
            color: #000;
          }

          .silver-on {
            background: #21ea79;
            .spin-pill-sub {
              color: #000;
            }
          }
          .gold-on {
            background: radial-gradient(131.35% 82.51% at 78.26% 95.76%, #59ffc7 0%, rgba(94, 255, 202, 0) 69.06%),
              radial-gradient(125.39% 72.75% at 59.78% 103.39%, #59ffc7 0%, rgba(94, 255, 202, 0) 100%),
              radial-gradient(122.75% 99.43% at 82.17% 101.69%, #16ffef 63.41%, rgba(116, 182, 255, 0) 100%), #3bfe90;
            .spin-pill-sub {
              color: #000;
            }
          }
          .spin-off {
            background: #ebebeb;
            .spin-pill-sub {
              color: #5f656a !important;
            }
          }
        }
      }

      .ways-card {
        .card-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px;

          .card-head-left {
            display: flex;
            align-items: center;
            gap: 8px;
            font-family: 'TikTokSans-Bold';
            font-weight: 900;
            font-style: italic;
            font-size: 20px;
            line-height: 24px;
            color: #000000;
          }
        }

        .ways-body {
          padding: 0 0 16px;

          .stats-bar {
            position: relative;
            display: flex;
            align-items: center;
            margin: 0 12px 16px;
            padding: 15px;
            min-height: 60px;
            background: #21ea79;
            border: 1px solid #21ea79;
            border-radius: 12px;

            .stats-left {
              display: flex;
              align-items: center;
              gap: 12px;

              .stat {
                display: flex;
                align-items: center;
                gap: 8px;
                font-family: 'TikTokSans-Bold';
                font-weight: 800;
                font-size: 18px;
                color: #202326;
                img {
                  width: 28px;
                  height: 28px;
                  object-fit: contain;
                }
              }
            }

            .stats-rank-link {
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              display: flex;
              align-items: center;
              gap: 4px;
              font-family: 'TikTokSans-Bold';
              font-weight: 700;
              font-size: 12px;
              color: #000000;
              text-decoration: underline;
              text-underline-offset: 3px;
              text-decoration-thickness: 1px;
              text-decoration-color: #000000;
              img {
                width: 16px;
                height: 16px;
              }
            }
          }

          .task-block-divider {
            height: 1px;
            margin: 16px 16px;
            background: #ededed;
          }

          .task-block {
            padding: 0 16px;

            .task-block-title {
              margin: 0;
              font-family: 'TikTokSans-Bold';
              font-weight: 700;
              font-size: 16px;
              color: #000000;
            }

            .task-block-sub {
              margin: 4px 0 12px;
              font-family: 'TikTokSans-Regular';
              font-weight: 500;
              font-size: 12px;
              color: #8e9092;
            }

            .task-row {
              display: flex;
              align-items: stretch;
              gap: 8px;
              margin-bottom: 8px;
              padding: 12px 10px 8px;
              background: #fff;
              border-radius: 12px;

              .task-row-main {
                flex: 1;
                min-width: 0;

                .task-desc {
                  font-size: 14px;
                  color: #202326;
                  .task-desc-proc {
                    color: #8e9092;
                  }
                }

                .task-desc-plain {
                  font-size: 12px;
                  line-height: 20px;
                  color: #202326;
                  display: flex;
                  align-items: center;
                }

                .task-row-reward {
                  margin-top: 6px;
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  gap: 10px;

                  .task-reward-item {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;

                    .task-reward-ic {
                      width: 22px;
                      height: 22px;
                      object-fit: contain;
                    }

                    > span {
                      font-family: 'TikTokSans-Bold';
                      font-size: 14px;
                      font-weight: 500;
                      color: #202326;
                    }
                  }
                }
              }

              .task-go {
                align-self: center;
                padding: 10px 20px;
                border-radius: 12px;
                border-bottom: 0.5px solid #21ea79;
                background: #21ea79;
                font-family: 'TikTokSans-Bold';
                font-weight: 600;
                font-size: 15px;
                color: #000000;
                white-space: nowrap;
              }

              .task-btn-wait {
                align-self: center;
                width: 88px;
                padding: 10px 5px;
                border-radius: 12px;
                background: #f5f5f5;
                font-family: 'TikTokSans-Regular';
                font-weight: 500;
                font-size: 15px;
                color: #b4b4b4;
                text-align: center;
                white-space: nowrap;
              }
            }

            .task-row-streak {
              .task-streak-done {
                align-self: center;
                padding: 10px 20px;
                border-radius: 12px;
                background: #f5f5f5;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;

                img {
                  width: 20px;
                  height: 20px;
                }
              }

              .task-streak-head {
                .streak-task-title {
                  display: block;
                  min-width: 0;
                }
              }

              .task-streak-bar-row {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-top: 8px;

                .task-streak-bar {
                  width: 120px;
                  height: 6px;
                  border-radius: 3px;
                  border: 0.5px solid #ffeed4;
                  background: #fff0d4;
                  overflow: hidden;

                  .task-streak-bar-fill {
                    height: 100%;
                    border-radius: 3px;
                    background: #ffcd06;
                    transition: width 0.2s ease;
                  }
                }

                .task-streak-progress {
                  flex-shrink: 0;
                  font-family: 'TikTokSans-Regular';
                  font-weight: 400;
                  font-size: 12px;
                  line-height: 20px;
                  color: #8e9092;

                  &.is-done {
                    color: #8e9092;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .act-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
    box-sizing: border-box;

    .dia-bg {
      width: 315px;
      max-width: 100%;
      border-radius: 16px;

      .con-block {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        padding-bottom: 20px;
        border-radius: 16px;
        border: 2px solid #242e80;
        background: #242e80;
        overflow: hidden;

        .gifts-dia-head {
          position: relative;
          width: 100%;
          min-height: 72px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px 16px 0;
          box-sizing: border-box;

          span {
            font-family: 'TikTokSans-Bold';
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            color: #ffffff;
            text-align: center;
          }
        }

        .gifts-reward1 {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 8px 16px;
          box-sizing: border-box;

          .gifts-reward1-cell {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
          }

          .img-wrap {
            width: 70px;
            height: 70px;
            border-radius: 8px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;

            img {
              max-width: 60px;
              max-height: 60px;
              width: auto;
              height: auto;
              object-fit: contain;
            }

            .avatar-bar {
              max-width: 60px;
              max-height: 60px;
            }
          }

          .rewards-count {
            font-family: 'TikTokSans-Bold';
            font-weight: 800;
            font-style: italic;
            font-size: 12px;
            line-height: normal;
            color: #ffffff;
            text-align: center;
          }
        }

        .gifts-reward2 {
          width: 100%;
          box-sizing: border-box;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 10px 6px;
          padding: 16px 24px 8px;
        }

        .gifts-reward2-cell {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
          min-width: 0;

          .img-wrap {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            background: rgba(255, 255, 255, 0.9);
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;

            img {
              max-width: 36px;
              max-height: 36px;
              width: auto;
              height: auto;
              object-fit: contain;
            }

            .avatar-bar {
              max-width: 36px;
              max-height: 36px;
            }
          }

          .rewards-count {
            font-family: 'TikTokSans-Bold';
            font-weight: 800;
            font-style: italic;
            font-size: 12px;
            line-height: normal;
            color: #ffffff;
            text-align: center;
            width: 100%;
          }

          &.gifts-reward2-cell--stagger {
            opacity: 0;
            animation: mayday-reward-pop 0.2s ease-out forwards;
          }
        }

        .gifts-confirm {
          width: 275px;
          max-width: calc(100% - 32px);
          height: 52px;
          margin: 0 auto;
          padding: 10px 24px;
          box-sizing: border-box;
          border-radius: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #21ea57;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;

          span {
            font-family: 'TikTokSans-Bold';
            font-weight: 600;
            font-size: 20px;
            line-height: normal;
            color: #000000;
            text-align: center;
          }

          &:active {
            opacity: 0.92;
          }
        }
      }
    }
  }
}

@keyframes mayday-reward-pop {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .mayday-root .mayday-scroll .ways-card .ways-body .stats-bar .stats-rank-link {
    right: unset;
    left: 12px;
  }
  .mayday-root .mayday-scroll .ways-card .ways-body .task-block .task-row .task-go,
  .mayday-root .mayday-scroll .ways-card .ways-body .task-block .task-row .task-btn-wait,
  .mayday-root .mayday-scroll .ways-card .ways-body .task-block .task-row .task-streak-done {
    margin-left: 8px;
  }
  .mayday-root .mayday-main .mayday-scroll .ways-card .ways-body .stats-bar .stats-rank-link img {
    transform: rotateY(180deg);
  }
}
</style>

<style>
.act-mayday-bean {
  width: 36px;
  height: 36px;
}
</style>
